import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
// import { Link } from 'react-router-dom';
// import { isEmpty } from 'lodash';
import Switch from 'react-switch';
import { Alert, Button, TabContent, TabPane, Card, CardBody, Col, FormGroup, Row } from 'reactstrap';
import { toast } from 'react-toastify';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// import TabNav from '../managed-product/section/TabNav';
import LoaderButton from '../loader-button/LoaderButton';
// import BzCardHeader from '../bz/BzCardHeader';
import CredsModal from '../managed-product/Vendor/CredsModal';
import SnStatsTab from './sn-stats/SnStatsTab';
// services
import BZAPIService from '../../services/BZAPIService';
//libs
import { useFormFields } from '../../libs/hooksLib';
import { FieldGroup } from '../../libs/formLib';
import { adminIsReadOnlyCheck } from '../../helpers/rbac';
// constants
import SETTINGS from '../../constants/settings';
import ButtonIcon from '../common/ButtonIcon';
import Loader from '../common/Loader';
import ValidationStepsDisplay from '../common/ValidationStepsDisplay';
import { ServiceNowIntegrationContext } from '../../context/DashboardContext';
// import Divider from '../common/Divider';

const ConfigServiceNow = () => {
  const [isValidUrl, setIsValidUrl] = useState(false);
  const [isReadOnly, setIsReadOnly] = useState(true);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isValidCredentials, setIsValidCredentials] = useState(false);
  const [isTestingValidCredentials, setIsTestingValidCredentials] = useState(false);
  const [isAddingCredentials, setIsAddingCredentials] = useState(false);
  const [validationMetadata, setValidationMetadata] = useState([]);
  const [Ip, setIp] = useState('');
  const [fields, handleFieldChange] = useFormFields({
    snApiUrl: '',
    secretId: '',
    user: '',
    pass: ''
  });
  const [shareBugClosureData, setshareBugClosureData] = useState(true);
  const [companyDomainSep, setCompanyDomainSep] = useState(false);
  // const [snIntegrationCheck, setSnIntegrationCheck] = useState(false);
  const [snIntegrationTest, setSnIntegrationTest] = useState({});

  const [activeTab, setActiveTab] = useState('1');

  // eslint-disable-next-line
  const [snIntegration, setSnIntegration] = useContext(ServiceNowIntegrationContext);

  const navigate = useNavigate();
  useEffect(() => {
    async function onLoad() {
      try {
        // Load permissions first so a failure in an unrelated call below can't leave the page stuck as read-only
        const myUserPermissions = await BZAPIService.getMyUserPermissions();
        setIsReadOnly(adminIsReadOnlyCheck(myUserPermissions));

        let settings = await BZAPIService.getSetting(SETTINGS.SERVICE_NOW);

        // publicIp is informational only — don't let a failure here abort the rest of onLoad
        let publicIP;
        try {
          publicIP = await BZAPIService.getPublicIP();
        } catch (ipErr) {
          console.log('getPublicIP failed', ipErr);
        }

        if (!settings)
          settings = {
            secretId: '',
            snApiUrl: '',
            snAuthToken: '',
            shareBugClosureData: 1
          };
        fields.secretId = settings.secretId;
        fields.snApiUrl = settings.snApiUrl;
        if (!settings.shareBugClosureData) settings.shareBugClosureData = 1;
        setshareBugClosureData(settings.shareBugClosureData === 1 ? true : false);
        // Default companyDomainSep to false (0) if not present
        if (settings.companyDomainSep === undefined) settings.companyDomainSep = 0;
        setCompanyDomainSep(settings.companyDomainSep === 1 ? true : false);
        // console.log('publicip', publicIP);
        setIp(publicIP?.publicIp || 'IP not found.');
        // !settings || isEmpty(settings) ? setSnIntegrationCheck(false) : setSnIntegrationCheck(true);
        if (settings) {
          const snIntegrationTest = await BZAPIService.sNConectionTest();
          setSnIntegrationTest(snIntegrationTest);

          // Update ServiceNow integration context on initial load
          setSnIntegration({
            isConfigured: snIntegrationTest?.valid ? true : false,
            testResult: snIntegrationTest || {}
          });
        } else {
          // No settings, mark as not configured
          setSnIntegration({
            isConfigured: false,
            testResult: {}
          });
        }
        setIsLoading(false);
      } catch (e) {
        console.log(e);
        setIsLoading(false);
      }
    }

    onLoad();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fields.secretId]);
  async function saveAWSSecret() {
    const data = {
      secret: {
        user: fields.user,
        pass: fields.pass
      },
      vendorId: 'servicenow',
      key: 'snAuth'
    };
    // service api secret
    return BZAPIService.createOrUpdateAWSSecret(data);
  }

  async function saveConfig(secret) {
    const data = {
      secretId: secret.Name,
      snApiUrl: fields.snApiUrl,
      type: 'global',
      shareBugClosureData: shareBugClosureData === true ? 1 : 0,
      companyDomainSep: companyDomainSep === true ? 1 : 0
    };

    const syncOnly = false;

    return BZAPIService.saveSetting(SETTINGS.SERVICE_NOW, syncOnly, data);
  }
  async function handleSave() {
    try {
      // validate url
      let validUrl;
      try {
        const parsed = new URL(fields.snApiUrl);
        validUrl = parsed.protocol === 'http:' || parsed.protocol === 'https:' ? [fields.snApiUrl] : null;
      } catch {
        validUrl = null;
      }
      console.log('validUrl', validUrl);
      if (!validUrl) setIsValidUrl(false);
      else setIsValidUrl(true);
      setIsSubmitted(true);
      setIsLoading(true);
      // Validate
      if (!fields.snApiUrl || !validUrl) {
        setIsLoading(false);

        return;
      }

      // Validate Secrets
      if (!fields.secretId) {
        if (!fields.user || !fields.pass) {
          console.log('misisng secret');
          setIsLoading(false);
          return;
        }
      }

      let secret;

      if (fields.user && fields.pass) {
        // Updated secrets
        secret = await saveAWSSecret();
      } else {
        // use existing secrets
        secret = { Name: fields.secretId };
      }
      // console.log('secret', secret);
      if (!secret || !secret.Name) {
        setIsLoading(false);
        throw Error('Missing Secret');
      }

      await saveConfig(secret);

      // Update ServiceNow integration context
      const snTestResult = await BZAPIService.sNConectionTest();
      setSnIntegration({
        isConfigured: true,
        testResult: snTestResult || {}
      });

      setIsLoading(false);
      setIsSubmitted(false);
      toast.success(`Settings Saved!`);
    } catch (e) {
      setIsLoading(false);
      toast.error('Failed to save.');
      console.log('e', e);
    }
    // Go back to listing
  }

  async function testCreds() {
    setIsTestingValidCredentials(true);
    setValidationMetadata([]);
    const data = {
      user: fields.user,
      pass: fields.pass,
      snApiUrl: fields.snApiUrl
    };
    const result = await BZAPIService.integrationServiceNowTest(data);
    setIsTestingValidCredentials(false);
    if (result) {
      // Store validation metadata if available
      if (result.metadata && Array.isArray(result.metadata)) {
        setValidationMetadata(result.metadata);
      }

      // valid creds
      if (!result.valid) {
        return toast.error(`Unable to validate ServiceNow credentials.`);
      }
      setIsValidCredentials(true);
      setIsAddingCredentials(false);
      toast.success(`ServiceNow credentials validated.`);
    } else {
      toast.error(`Unable to validate ServiceNow credentials.`);
    }

    // console.log('result', result);
  }

  const toggleTab = tab => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  // BugZero token-styled tab strip (matches the managed-product config nav).
  // Same tabs, ids, data-testids and toggle behavior as before.
  const SN_TABS = [
    { id: '1', label: 'Overview', testid: 'overview-tab' },
    { id: '2', label: 'Whitelisting', testid: 'default-config-tab' },
    { id: '3', label: 'Credentials', testid: 'filtering-tab' },
    { id: '4', label: 'Data sharing', testid: 'filtering-tab' },
    { id: '5', label: 'Stats', testid: 'stats-tab' }
  ];

  const TabNav = () => (
    <div
      className="bz-row bz-scroll"
      style={{ gap: 2, borderBottom: '1px solid var(--line)', marginBottom: 20, overflowX: 'auto' }}
    >
      {SN_TABS.map(t => {
        const on = activeTab === t.id;
        return (
          <button
            key={t.id}
            type="button"
            data-testid={t.testid}
            onClick={() => toggleTab(t.id)}
            style={{
              all: 'unset',
              whiteSpace: 'nowrap',
              cursor: 'pointer',
              padding: '10px 14px',
              fontSize: 'var(--fs-md)',
              fontWeight: on ? 600 : 500,
              color: on ? 'var(--ink)' : 'var(--ink-soft)',
              borderBottom: on ? '2px solid var(--prevent)' : '2px solid transparent',
              transition: 'color .12s'
            }}
            onMouseEnter={e => {
              if (!on) e.currentTarget.style.color = 'var(--ink)';
            }}
            onMouseLeave={e => {
              if (!on) e.currentTarget.style.color = 'var(--ink-soft)';
            }}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );

  if (isLoading && !isSubmitted) return <Loader text="Loading ServiceNow settings..." />;
  return (
    <>
      {/* Identity header (BugZero design) — matches the vendor configuration chrome. */}
      <div
        className="bz-card"
        style={{ display: 'flex', alignItems: 'center', gap: 16, padding: '16px 20px', marginBottom: 20 }}
      >
        <div
          style={{
            width: 44,
            height: 44,
            borderRadius: 10,
            background: 'var(--bg-tan)',
            color: 'var(--bz-blue-2)',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 700,
            fontSize: 15,
            flexShrink: 0
          }}
        >
          SN
        </div>
        <div style={{ minWidth: 0 }}>
          <div className="bz-kicker" style={{ color: 'var(--prevent)' }}>
            Integration
          </div>
          <div className="bz-row" style={{ gap: 10, marginTop: 2 }}>
            <h1 className="bz-h2" style={{ margin: 0 }} data-testid="heading">
              ServiceNow
            </h1>
            {snIntegrationTest?.valid ? (
              <span className="bz-pill bz-pill--ok">
                <span className="bz-dot" />
                Connected
              </span>
            ) : (
              <span className="bz-pill">
                <span className="bz-dot" />
                Not connected
              </span>
            )}
            {isReadOnly && <span className="bz-pill bz-pill--warn">Read-only</span>}
          </div>
          <div className="bz-muted" style={{ fontSize: 'var(--fs-sm)', marginTop: 4 }}>
            Connect BugZero to your ServiceNow instance to route findings to tasks.
          </div>
        </div>
      </div>
      {isReadOnly && (
        <Alert color="info">Note: Your user only has read-only access. You will not be able to save any updates.</Alert>
      )}

      <TabNav />
      {/* Tab 1 */}
      <TabContent>
        <div style={{ minWidth: '100%' }}>
          <TabPane tabId="1">
            {activeTab === '1' ? (
              <Card>
                <CardBody>
                  <Row>
                    <Col xs={6} className="col-xxl-4 mb-1 pr-md-2 pl-xxl-2">
                      <Card className="mb-3 overflow-hidden" style={{ minWidth: '24rem', minHeight: '8rem' }}>
                        <CardBody className="position-relative">
                          <Row>
                            <Col>
                              <h6 className="dash-vendor-label">ServiceNow</h6>
                            </Col>
                            <Col className="text-right d-inline-flex flex-row-reverse">
                              <p className={`branding-${snIntegrationTest?.valid ? 'green' : 'red'} small`}>
                                <span className="pb-2">{snIntegrationTest?.valid ? 'OPERATIONAL' : 'ERROR'}</span>
                              </p>
                              <p className="small">
                                <span className="fa-stack fa-xs mr-1">
                                  <FontAwesomeIcon
                                    icon="circle"
                                    className={`branding-${snIntegrationTest?.valid ? 'green' : 'red'} fa-stack-2x`}
                                  />
                                  <FontAwesomeIcon
                                    icon={snIntegrationTest?.valid ? 'check' : 'exclamation'}
                                    className="fa-stack-1x"
                                    inverse
                                  />
                                </span>
                              </p>
                            </Col>
                          </Row>
                          {!snIntegrationTest?.valid ? (
                            <div>
                              <div className="col">
                                <div className="row">
                                  <Button
                                    color="falcon-default"
                                    className="btn btn-falcon-default mt-2"
                                    size="sm"
                                    onClick={() => {
                                      toggleTab('3');
                                    }}
                                  >
                                    Configure
                                  </Button>
                                </div>
                              </div>

                              <>
                                <div className="active">
                                  <small>{snIntegrationTest?.error?.message}</small>
                                </div>
                              </>
                            </div>
                          ) : (
                            <></>
                          )}
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            ) : (
              <></>
            )}
          </TabPane>
        </div>
        {/* Tab 2 */}
        <div style={{ minWidth: '100%' }}>
          <TabPane tabId="2">
            {activeTab === '2' ? (
              <Card className="mb-4">
                <CardBody>
                  <div className="col text-right">
                    <a
                      href="https://docs.servicenow.com/en-US/bundle/utah-platform-security/page/administer/login/task/t_AccessControl.html"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-falcon-default ml-2 btn-sm"
                    >
                      <FontAwesomeIcon icon="book" className="mr-2" />
                      Whitelisting Guide
                    </a>
                  </div>
                  <Col>
                    <p>
                      <strong className="text-bold mr-2">Source IP for Whitelisting:</strong>
                      <span className="branding-red" data-testid={'ip-whitelisting'}>
                        {Ip}
                      </span>
                    </p>
                  </Col>
                </CardBody>
              </Card>
            ) : (
              <></>
            )}
          </TabPane>
        </div>
        {/* Tab 3 */}
        <div style={{ minWidth: '100%' }}>
          <TabPane tabId="3">
            {activeTab === '3' ? (
              <Card className="mb-4">
                <CardBody className="fs--1">
                  <FormGroup lg="5">
                    <FieldGroup
                      type="text"
                      label="ServiceNow URL"
                      id="snApiUrl"
                      data-testid={'sn-url'}
                      onChange={handleFieldChange}
                      value={fields.snApiUrl}
                      placeholder="Enter URL"
                      // style={{ marginBottom: '10px' }}
                      help="E.g. https://company-name.service-now.com"
                      feedback="Please specify a valid url starting with http or https."
                      showFeedback={!isValidUrl && isSubmitted}
                    />
                  </FormGroup>
                  <Row form>
                    <Col lg="12">
                      <FormGroup>
                        {!isAddingCredentials ? (
                          <div className="d-flex align-items-center">
                            <ButtonIcon
                              onClick={() => setIsAddingCredentials(true)}
                              color="falcon-default"
                              size="sm"
                              disabled={!fields.snApiUrl}
                              icon="plus"
                              iconClassName="fs--2"
                              className="mr-2"
                              data-testid={'sn-set-credentials-btn'}
                            >
                              Set Credentials
                            </ButtonIcon>
                            {fields.secretId || isValidCredentials ? (
                              <div className="d-flex align-items-center" data-testid={'sn-creds-stored-message'}>
                                <FontAwesomeIcon icon={'check'} style={{ color: 'green' }} className="mr-1" />
                                ServiceNow API Credentials Stored
                              </div>
                            ) : null}
                          </div>
                        ) : (
                          <>
                            <Row>
                              <Col lg="6">
                                <FieldGroup
                                  type="text"
                                  label="ServiceNow API Credentials"
                                  id="user"
                                  data-testid={'sn-username-input'}
                                  onChange={handleFieldChange}
                                  value={fields.user}
                                  placeholder="Enter username"
                                  style={{ marginBottom: '10px' }}
                                />
                              </Col>
                              <Col lg="6">
                                <FieldGroup
                                  type="password"
                                  label="&nbsp;"
                                  id="pass"
                                  data-testid={'sn-password-input'}
                                  placeholder="Enter password"
                                  onChange={handleFieldChange}
                                  value={fields.pass}
                                  help="We will auto-generate a token based off the credentials you
													enter."
                                />
                              </Col>
                            </Row>
                            <br />
                            <CredsModal
                              isTestingValidCredentials={isTestingValidCredentials}
                              setIsTestingCredentials={setIsTestingValidCredentials}
                              fields={fields}
                              testCreds={testCreds}
                              vendorId={'servicenow'}
                            />
                            <Button
                              onClick={() => setIsAddingCredentials(false)}
                              color="falcon-danger"
                              data-testid={'sn-cancel-creds'}
                              // size="sm"
                              iconClassName="fs--2"
                              style={{ marginRight: '10px' }}
                            >
                              Cancel
                            </Button>
                          </>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                  {validationMetadata && validationMetadata.length > 0 && (
                    <Row>
                      <Col lg="12">
                        <ValidationStepsDisplay
                          validationResults={validationMetadata}
                          title="ServiceNow Credential Validation"
                        />
                      </Col>
                    </Row>
                  )}
                  <Row>
                    <Col lg="12" className="mt-3">
                      <Switch
                        id={'company-domain-sep-switch'}
                        onChange={e => setCompanyDomainSep(e)}
                        checked={companyDomainSep}
                        data-testid={'company-domain-sep'}
                        uncheckedIcon={false}
                        onColor="#253746"
                        height={14}
                        width={28}
                      />
                      <label className="ml-2 pb-1">Enable CI Company Domain Separation</label>
                      <p className="text-muted small mt-1">
                        When enabled, the ServiceNow integration will require CIs to have a populated Company field and
                        will apply additional validation for domain-separated environments.
                      </p>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            ) : (
              <></>
            )}
          </TabPane>
        </div>
        <div style={{ minWidth: '100%' }}>
          <TabPane tabId="4">
            {activeTab === '4' ? (
              <Card className="mb-4">
                <CardBody>
                  <Col>
                    <p>
                      Choose whether or not you would like to anonymously share data from your ServiceNow instance to
                      further enhance bug risk scoring and help others avoid disruptions.
                    </p>
                    <Switch
                      id={'closure-share-switch'}
                      onChange={e => setshareBugClosureData(e)}
                      checked={shareBugClosureData}
                      data-testid={'bug-closure-share'}
                      uncheckedIcon={false}
                      onColor="#253746"
                      height={14}
                      width={28}
                    />
                    <label className="ml-2 pb-1 ">Anonymously share bug data with BugZero&apos;s community</label>
                  </Col>
                </CardBody>
              </Card>
            ) : (
              <></>
            )}
          </TabPane>
        </div>
        <div style={{ minWidth: '100%' }}>
          <TabPane tabId="5">{activeTab === '5' ? <SnStatsTab snApiUrl={fields.snApiUrl} /> : <></>}</TabPane>
        </div>
      </TabContent>

      <Row className="flex-between-center" style={{ marginTop: '40px' }}>
        <Col xs="auto">
          <Button
            block
            color="falcon-danger"
            data-testid={'cancel-btn'}
            onClick={() => {
              navigate(-1);
            }}
          >
            Cancel
          </Button>
        </Col>
        <Col xs="auto">
          <LoaderButton
            block
            color="falcon-primary"
            onClick={handleSave}
            name="save-and-add"
            isLoading={isLoading}
            disabled={isReadOnly}
          >
            Save changes
          </LoaderButton>
        </Col>
      </Row>
    </>
  );
};

export default ConfigServiceNow;
